import AppShell from "@/components/layout/AppShell";
import PageHeader from "@/components/ui/PageHeader";
import { Table, TD, TH, THead } from "@/components/ui/Table";
import { store } from "@/lib/store";

export default function SuppliersPage() {
    const suppliers = store.getSuppliers();

    return (
        <AppShell>
            <PageHeader title="Suppliers" description="Manage Bangkok and Hong Kong sourcing contacts." />
            <Table>
                <table className="min-w-full border-collapse">
                    <THead>
                        <tr>
                            <TH>Name</TH>
                            <TH>Contact Person</TH>
                            <TH>Mobile</TH>
                            <TH>City</TH>
                            <TH>Origin</TH>
                        </tr>
                    </THead>
                    <tbody>
                        {suppliers.map((supplier) => (
                            <tr key={supplier.id} className="border-t border-rose-50">
                                <TD>{supplier.name}</TD>
                                <TD>{supplier.contactPerson}</TD>
                                <TD>{supplier.mobile}</TD>
                                <TD>{supplier.city}</TD>
                                <TD>{supplier.origin}</TD>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Table>
        </AppShell>
    );
}